import React from 'react';
import ScheduleBoard from '../components/production/schedule/ScheduleBoard';

export default function ProductionSchedulePage() {
    return <ScheduleBoard />;
}
